<div class="grid">
  <div>Glossary</div>
  <div>Actuarial Assumptions</div>
  <div>
    <app-actuarial-assumptions-info></app-actuarial-assumptions-info>
  </div>
  <div *ngIf="displayRetirementDate">Add Retirement Date</div>
  <div *ngIf="displayRetirementDate">
    <app-add-retirement-date-info></app-add-retirement-date-info>
  </div>
  <div *ngIf="displayESPS">Average Pensionable Earnings (ESPS)</div>
  <div *ngIf="displayESPS">
    <app-average-pensionable-earnings-esps-info></app-average-pensionable-earnings-esps-info>
  </div>
  <div>Average Pensionable Earnings (RPP)</div>
  <div>
    <app-average-pensionable-earnings-sps-info *ngIf="hasSPP()"></app-average-pensionable-earnings-sps-info>
    <app-average-pensionable-earnings-info *ngIf="!hasSPP()"></app-average-pensionable-earnings-info>
  </div>
  <div *ngIf="displayEffectiveDate">Effective Date</div>
  <div *ngIf="displayEffectiveDate">
    <app-effective-date-info></app-effective-date-info>
  </div>
  <div>Comparison of Retirement Types</div>
  <div>
    <app-comparison-retirement-types *ngIf="!isESPS()"></app-comparison-retirement-types>
    <app-comparison-retirement-types-esps *ngIf="isESPS()"></app-comparison-retirement-types-esps>
  </div>
  <div *ngIf="!displayMarried">Form of Pension Payment</div>
  <div *ngIf="!displayMarried">
    <app-form-of-pension-payment-info></app-form-of-pension-payment-info>
  </div>
  <div *ngIf="displayMarried">Form of Pension Payment</div>
  <div *ngIf="displayMarried">
    <app-form-of-pension-payment-married-info></app-form-of-pension-payment-married-info>
  </div>
  <div>Future Percentage of Work</div>
  <div>
    <app-future-percentage-info></app-future-percentage-info>
  </div>
  <div>Terms & Conditions</div>
  <div>
    <app-terms-and-conditions-info></app-terms-and-conditions-info>
  </div>
  <div>Yearly Salary Increase</div>
  <div>
    <app-yearly-salary-info></app-yearly-salary-info>
  </div>
</div>
